import React from 'react';
import { Col, Form } from 'react-bootstrap';
import colegiosList from '../../data/colegios'

// Colegios
const ColegiosInput = ({ c, i, values, handleInputChange }) => {
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group>
        <Form.Label>{c.name + ' *'}</Form.Label>
        <input
          className={`form form-control ${
            values.colegio
              ? values.colegio.length > 3
                ? 'is-valid'
                : 'is-invalid'
              : ''
          }`}
          list="listColegios"
          name="colegio"
          onChange={handleInputChange}
        />
        <datalist id="listColegios" className="form">
          {colegiosList.map((e) => (
            <option value={`${e.nombre}`} key={`${e.nombre}`}>
              {e.nombre}
            </option>
          ))}
        </datalist>
      </Form.Group>
    </Col>
  );
};

export default ColegiosInput;
